import React from 'react';
import { Select } from 'antd';
import Field from '../../../../shared/ui/Field';
import { useFieldController } from '../../../../../../helpers/formManager';
import { dateSettingValueEnum, fieldNames } from '../../constants';
import styles from './index.module.scss';

const options = [
  { label: 'Дату начала', value: dateSettingValueEnum.START_DATE },
  { label: 'Дату окончания', value: dateSettingValueEnum.END_DATE },
  { label: 'Период', value: dateSettingValueEnum.PERIOD },
];

const SelectCleanableDateEntity = () => {
  const { field, fieldState } = useFieldController({
    name: fieldNames.cleanableDateEntity,
    rules: { required: 'Выберите, что очистить' },
  });

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel="Что очистить"
      required
      value={field.value}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      onChange={field.onChange}
      rootCN={styles.root}
      style={{ width: '100%' }}
    >
      {options.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
};

export default SelectCleanableDateEntity;
